// extracted by mini-css-extract-plugin
export default {"grid":"HistoryTripleImages_grid__Qus5p","cell":"HistoryTripleImages_cell__Pi9tO","elevated":"HistoryTripleImages_elevated__CaMAZ","image":"HistoryTripleImages_image__nVGte"};